import React from "react";
import { PageContainer } from "@amzn/stencil-react-components/page";
import { Text } from "@amzn/stencil-react-components/text";
import { Col } from "@amzn/stencil-react-components/layout";
import { HVH_COLORS } from "../../config/palette";
import * as adobeAnalytics from "../../utility/adobe-analytics";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

const applicationIdWhenErr = () => window.location.href.split("/").pop();

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    // TBD: Log error using Client Side Error Tracker: https://code.amazon.com/packages/HvhClientSideErrorTracker/trees/mainline
    adobeAnalytics.addEventMetric(window, applicationIdWhenErr() as string, "Ash page unable to load");
  }

  render() {
    if (this.state.hasError) {
      return (
        <Col height="100vh">
          <PageContainer color={HVH_COLORS.NEUTRAL_90} height="100%">
            <Col alignItems="center" justifyContent="center" height="100%">
              <Text fontWeight="regular" fontSize="T300" textAlign="center">
                Something went wrong <br />
                We are working to fix it
              </Text>
            </Col>
          </PageContainer>
        </Col>
      );
    }

    return this.props.children;
  }
}
